<template>
    <div class="my-3">
        <ul v-if="paymentMethods">
            <li v-for="(refund, index) in reservation.billing.refunds" class="d-flex mb-3">
                <div class="d-flex">
                    <div class="flex-all mr-3">
                        <label>Payment Method</label>
                        <vSelect 
                            v-model="refund.type" 
                            :options="paymentMethods" 
                            placeholder="- Select type -" 
                            label="description">
                        </vSelect>
                    </div>

                    <div class="flex-all">
                        <label>Amount</label>
                        <input type="number" class="mb-0 text-right" v-model="refund.value" @keyup="validateRefunds">
                    </div>

                    <div v-if="index > 0" class="pointer mt-5 ml-4" @click="deleteRow(index)">
                        <i class="ico-delete largest"></i>
                    </div>
                    <div v-else class="pointer color-1 ml-4 mt-5" @click="addRow(refund.type)">
                        <i class="ico-add add-circle"></i>
                    </div>
                </div>
            </li>
        </ul>

        <ul v-if="!validTotal">
            <li class="d-flex error align-items-center mb-4">
                <i class="ico-alert largest"></i>
                The total refund doesn't match the total payment for this product.
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import { reservationsMixin } from '@/mixins/reservations'

    export default {
        mixins: [reservationsMixin],
        data: function () {
            return {
                reservation: {},
            }
        },
        created: function() {
            if (this.getSelectedReservation) {
                this.reservation = JSON.parse(JSON.stringify(this.getSelectedReservation));
            }
        },
        asyncComputed: {
            async paymentMethods() {
                try {
                    let response = await axios.get('/api/settings/GetPaymentTypeList');

                    if (response && response.status === 200 && response.data) {
                        // Map FK information through selects

                        if (this.reservation.billing.refunds === undefined || !this.reservation.billing.refunds) {
                            console.log('Setting refunds array');
                            
                            this.$set(this.reservation.billing, 'refunds', []);
                            this.addRow(response.data[0]);
                        }

                        this.reservation.payments.forEach(payment => {
                            const found = response.data.find(p => p.id === payment.type);

                            if (found) {
                                this.$set(payment, 'type', found);
                            }
                        });

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
        },
        computed: {
            ...mapGetters([
                'getSelectedReservation'
            ]),
            refundsTotal: function() {
                let total = 0;
                
                if (this.reservation.billing.refunds !== undefined) {
                    this.reservation.billing.refunds.forEach(item => {
                        if (item.value === '') {
                            item.value = 0;
                        }
                        total += parseFloat(item.value);

                    });
                }

                return total;
            },
            validTotal: function() {
                // Validating if the amount isn't greater than what was paid 

                return (this.refundsTotal >= 0 && this.refundsTotal <= this.paid);
            },
        },
        methods: {
            ...mapActions([
                'addReservationRefund'
            ]),
            addRow: function(defaultType) {
                this.reservation.billing.refunds.push({
                    type: defaultType,
                    value: '0.00',
                    currency: '€'
                });
                
                console.log('Pushed new empty refunds row', this.reservation.billing.refunds);
            },
            deleteRow: function(row) {
               this.reservation.billing.refunds.splice(row, 1);
               this.validatePayments();
            },
            validateRefunds: function() {
                this.$emit('validateRefunds', !this.validTotal);
                this.$emit('updateRefunds', this.reservation.billing.refunds);
            },
            formatValue: function() {
                this.reservation.billing.refunds.forEach(function(item) {
                    item.value = this.formatPrice(item.value);
                });
            },
        },
        components: {
            vSelect: extendedVSelect,
        }
    }
</script>



// WEBPACK FOOTER //
// CancellationMethods.vue?ec304856